import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "contactos-previos"
}
const _hoisted_2 = { class: "cp-header" }
const _hoisted_3 = { class: "cp-titulo" }
const _hoisted_4 = { class: "cp-contador" }
const _hoisted_5 = { class: "cp-lista" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "cp-email" }
const _hoisted_8 = {
  key: 0,
  class: "cp-nombre"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "cp-vacio"
}
const _hoisted_11 = {
  key: 2,
  class: "cp-vacio"
}

import { ref, watch } from 'vue'
import type { ContactoGrupo } from '@/services/CalificacionOpinionPreguntaService'
import { getContactosGrupoService } from '@/services/CalificacionOpinionPreguntaService'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactosPreviosSelector',
  props: {
    idGrupoInteres: {},
    idPrograma: {},
    idEjecucion: {}
  },
  emits: ["agregar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Selector de destinatarios ya usados, desde el banco de correos.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const contactos = ref<ContactoGrupo[]>([])
const seleccionados = ref<string[]>([])
const cargado = ref(false)

watch(
  () => [props.idGrupoInteres, props.idPrograma, props.idEjecucion] as const,
  async () => {
    contactos.value = []
    seleccionados.value = []
    cargado.value = false

    if (!props.idGrupoInteres) return
    // Sin área (ni ejecución de la que sacarla) no hay a qué directorio pedirle.
    if (!props.idPrograma && !props.idEjecucion) return

    contactos.value = await getContactosGrupoService(props.idGrupoInteres, {
      id_programa: props.idPrograma ?? null,
      id_ejecucion: props.idEjecucion ?? null
    })
    cargado.value = true
  },
  { immediate: true }
)

/** Días que le quedan de afiliación; null si no tiene caducidad declarada. */
function diasRestantes(c: ContactoGrupo): number | null {
  if (!c.vigencia_hasta) return null
  const hasta = new Date(c.vigencia_hasta)
  if (Number.isNaN(hasta.getTime())) return null
  const hoy = new Date()
  hoy.setHours(0, 0, 0, 0)
  return Math.ceil((hasta.getTime() - hoy.getTime()) / 86_400_000)
}

/** Se avisa a partir de 6 meses: da margen para renovar la afiliación. */
function porVencer(c: ContactoGrupo): boolean {
  const dias = diasRestantes(c)
  return dias !== null && dias <= 180
}

function textoVigencia(c: ContactoGrupo): string {
  const dias = diasRestantes(c)
  if (dias === null) return 'sin caducidad'
  if (dias <= 30) return `vence en ${dias} día${dias === 1 ? '' : 's'}`
  if (dias <= 180) return `vence en ${Math.round(dias / 30)} meses`
  return `vigente hasta ${c.vigencia_hasta}`
}

function seleccionarTodos() {
  seleccionados.value = contactos.value.map(c => c.email)
}

function limpiar() {
  seleccionados.value = []
}

function agregar() {
  const elegidos = contactos.value
    .filter(c => seleccionados.value.includes(c.email))
    .map(c => ({ email: c.email, nombre: c.nombre ?? null }))

  emit('agregar', elegidos)
  seleccionados.value = []
}

return (_ctx: any,_cache: any) => {
  return (contactos.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _cache[1] || (_cache[1] = _createTextVNode(" Correos usados antes con este grupo en esta área ")),
            _createElementVNode("span", _hoisted_4, _toDisplayString(contactos.value.length), 1)
          ]),
          _createElementVNode("div", { class: "cp-acciones" }, [
            _createElementVNode("button", {
              type: "button",
              class: "cp-link",
              onClick: seleccionarTodos
            }, "Todos"),
            _createElementVNode("button", {
              type: "button",
              class: "cp-link",
              onClick: limpiar
            }, "Ninguno")
          ])
        ]),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactos.value, (c) => {
            return (_openBlock(), _createElementBlock("li", {
              key: c.id,
              class: "cp-item"
            }, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: c.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((seleccionados).value = $event))
                }, null, 8, _hoisted_6), [
                  [_vModelCheckbox, seleccionados.value]
                ]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(c.email), 1),
                (c.nombre)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(c.nombre), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(['cp-vigencia', { 'por-vencer': porVencer(c) }])
                }, _toDisplayString(textoVigencia(c)), 3)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm guardar",
          disabled: !seleccionados.value.length,
          onClick: agregar
        }, " Agregar " + _toDisplayString(seleccionados.value.length || '') + " a la lista ", 9, _hoisted_9)
      ]))
    : (cargado.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Todavía no hay correos registrados para este grupo de interés en esta área. Los que envíes ahora quedarán guardados para el próximo formulario. "))
      : (_ctx.idGrupoInteres && !_ctx.idPrograma && !_ctx.idEjecucion)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, " El banco de correos se guarda por grupo de interés y área. Esta ficha no tiene un área resuelta: ábrela desde su ejecución para ver los correos ya usados. "))
        : _createCommentVNode("", true)
}
}

})